export default "__VITE_ASSET__B6rg_9VN__"